<div class="display-grid select-dimension-option full-width gap-1-rem" [ngClass]="{ 'is-main': inject.option.isMain$ | async }">
  <app-metric-dimension-name [item]="inject.option.item"
                             class="full-width"
                             [showCategory]="inject.type === 'reminder'"></app-metric-dimension-name>
  <div class="display-flex flex-align-center justify-content-end select-dimension-option-slide full-height overflow-hidden">
    <mat-slide-toggle color="primary"
                      appClickStopPropagation
                      [disableRipple]="true"
                      [disabled]="inject.disabled || (inject.option.isMain$ | async)"
                      [checked]="inject.option.isMain$ | async"
                      (change)="mainDimensionSlide($event)">{{ 'reports.main' | translate }}</mat-slide-toggle>
  </div>
</div>
